import { type AudienceShare, type AudienceSharesByFee, type RevenueMethod, revenueMethodValues } from './types';

type ShareGroup = {
  recipients: { id: string; name: string; uid: string }[];
  revenueMethod: RevenueMethod;
  share_id: string;
  uids: string[];
};

const formatFee = (revenueMethod: RevenueMethod, pomFee: string | null, cpmFee: string | null): string => {
  if (revenueMethod === revenueMethodValues.PoM) {
    const percentage = Number.parseFloat(pomFee ?? '0') * 100;

    return `${percentage.toFixed()}`;
  }

  return cpmFee ?? '0';
};

export const groupAudienceSharesByFee = (audienceShares: AudienceShare[] = []): AudienceSharesByFee[] => {
  const grouped = audienceShares.reduce<Record<string, ShareGroup>>((acc, share) => {
    const fee = formatFee(share.revenue_method, share.third_party_revenue, share.cpm_cap);
    const recipient = {
      id: share.recipient_account_id,
      name: share.recipient_account_name,
      uid: share.uid,
    };

    const current = acc[fee];

    if (current) {
      current.recipients.push(recipient);
      current.uids.push(share.uid);
      current.revenueMethod = share.revenue_method;
      current.share_id = share.id;
    } else {
      acc[fee] = {
        recipients: [recipient],
        revenueMethod: share.revenue_method,
        share_id: share.id,
        uids: [share.uid],
      };
    }

    return acc;
  }, {});

  return Object.entries(grouped).map(([fee, value]) => ({
    recipients: value.recipients,
    fee,
    revenueMethod: value.revenueMethod,
    shareId: value.share_id,
    uids: value.uids,
  }));
};
